// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2saP6","dragIcon":"Choice_dragIcon__R4hCv","left":"Choice_left__2ofEv","input":"Choice_input__3ror4"};